import { Table } from 'coreOld/components';
import { TableNames } from 'coreOld/constants';

import { TableWrapper } from './pricingListStyle';

interface IProps {
  tableColumns?;
  pricingList?: any[];
  isLoading?: boolean;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onRowClick: (row) => void;
  fetchNextPage?;
}

const PricingListView = ({
  tableColumns,
  pricingList,
  isLoading,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onRowClick,
}: IProps) => {
  return (
    <TableWrapper>
      <Table
        columns={tableColumns}
        data={pricingList}
        name={TableNames.UOMS_LIST}
        alternating={false}
        headerLines={2}
        borderBottom={true}
        isLoading={isLoading}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
        onRowClick={onRowClick}
      />
    </TableWrapper>
  );
};

export default PricingListView;
